import { gql } from "@apollo/client";

export const GET_TOTAL_UNREAD_MESSAGES_COUNT = gql`
  query user {
    user {
      unreadMessagesCount
    }
  }
`;
